/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBodyExpensiveOrganizer_suggestionPayload = {
    readonly approximateMonthlyFocusHoursCost?: number | null | undefined;
    readonly calendarId?: string | null | undefined;
    readonly " $refType": "SuggestionBodyExpensiveOrganizer_suggestionPayload";
};
export type SuggestionBodyExpensiveOrganizer_suggestionPayload$data = SuggestionBodyExpensiveOrganizer_suggestionPayload;
export type SuggestionBodyExpensiveOrganizer_suggestionPayload$key = {
    readonly " $data"?: SuggestionBodyExpensiveOrganizer_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyExpensiveOrganizer_suggestionPayload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBodyExpensiveOrganizer_suggestionPayload",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "approximateMonthlyFocusHoursCost",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarId",
                    "storageKey": null
                }
            ],
            "type": "SuggestionResultExpensiveOrganizerPayload",
            "abstractKey": null
        }
    ],
    "type": "SuggestionResultPayload",
    "abstractKey": "__isSuggestionResultPayload"
} as any;
(node as any).hash = 'fa7e120f41b03568edc87154ed3ba600';
export default node;
